<div [formGroup]="form">
  <div class="row">
    <div class="col-sm-12">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          placeholder="Address"
          i18n-placeholder
          type="text"
          formControlName="address"
          [required]="form.get('address') | required"
        />
        <mat-error i18n *ngIf="form.get('address').touched && form.get('address').hasError('allSpaces')">
          Address cannot be spaces alone.
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          placeholder="City"
          i18n-placeholder
          type="text"
          formControlName="city"
          [required]="form.get('city') | required"
        />
      </mat-form-field2>
    </div>
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          placeholder="State / Province / Region"
          i18n-placeholder
          type="text"
          formControlName="state"
          [required]="form.get('state') | required"
        />
      </mat-form-field2>
    </div>
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <input
          matInput
          placeholder="Postal Code"
          i18n-placeholder
          type="text"
          formControlName="postal_code"
          [required]="form.get('postal_code') | required"
        />
      </mat-form-field2>
    </div>
    <div class="col-sm-6">
      <app-country-select [codeCtrl]="form.get('country_code')" [nameCtrl]="form.get('country')"></app-country-select>
    </div>
  </div>
</div>
